<template>
  <v-row>
    <v-col cols="12">
        <v-card color="kbWhite">
            <v-card-text>
                <v-row>
                    <v-col cols="12" class="text-center mt-4">
                        <h3 class="text-center kbDarkBlueText--text" >{{ $t('general.nameOfTheMassSms') }}</h3>
                        <span class="kbDarkBlueText--text">{{ $t('general.insertMassSmsKeyName') }}</span>
                    </v-col>
                </v-row>
                <v-row justify="center" >
                    <v-text-field class="mx-2 my-4"
                                  color="kbDarkBlueText"
                                  v-model="campaignName"
                                  style="max-width: 400px"
                                  outlined
                                  single-line
                                  clearable>
                    </v-text-field>
                    <input type="file"
                           style="display: none"
                           ref="fileInput"
                           accept=".csv,.xlsx,xls"
                           @change="onFilePicked">
                </v-row>
                <v-divider></v-divider>

                <v-row>
                    <v-col cols="12" class="text-center mt-4 mb-4">
                        <h3 class="text-center kbDarkBlueText--text" >{{ $t('general.loadFile') }}</h3>
                    </v-col>

                    <v-col class="text-center" cols="12" >
                        <h5 class="primary--text kbDarkBlueText--text">{{file ? file.name : $t('general.noFilePicked')}}</h5>
                    </v-col>

                    <v-col class="text-center" cols="12" >
                        <v-btn @click="onPickFile()"
                               color="kbPurple"
                               dark
                               large>
                            {{ $t('general.pickFile') }}
                            <v-icon right>
                                insert_drive_file
                            </v-icon>
                        </v-btn>
                    </v-col>
                </v-row>

                <v-divider class="mt-6 mb-4" ></v-divider>

                <v-row class="px-3">
                    <v-btn @click="downloadFormatImporter()"
                           color="kbPurple"
                           dark
                           outlined
                           :loading="downloadingFormatImporter">
                        {{ $t('general.downloadFormat') }}
                    </v-btn>

                    <v-spacer/>

                    <v-btn @click="prepareSms()"
                           color="kbPurple"
                           dark
                           :loading="loading">
                        <span class="hidden-xs-only">{{ $t('general.prepareMassSms') }}</span>
                        <v-icon right dark>check</v-icon>
                    </v-btn>
                </v-row>
            </v-card-text>
        </v-card>
    </v-col>
  </v-row>
</template>

<script>
import notifications from '@/libs/notifications'
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      listsPersons: state => state.listsPersons.listsPersons
    })
  },
  data () {
    return {
      campaignName: '',
      downloadingFormatImporter: false,
      file: '',
      loading: false,
      uploadingFile: false
    }
  },
  methods: {
    async downloadFormatImporter () {
      this.downloadingFormatImporter = true
      const link = document.createElement('a')
      link.href = 'https://storage.googleapis.com/keybe/app/files/formato_sms_masivo.xlsx'
      link.setAttribute('download', 'formato_sms_masivo.xlsx')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      this.downloadingFormatImporter = false
    },
    onPickFile () {
      this.$refs.fileInput.click()
    },
    onFilePicked (event) {
      this.uploadingFile = true
      const file = event.target.files[0]
      this.$set(file, 'status', 'pending')
      this.file = file
      event.target.value = ''
    },
    prepareSms () {
      if (!this.campaignName) return notifications.error(this.$t('general.insertMassSmsName'))
      if (!this.file) return notifications.error(this.$t('general.mustPickSmsFile'))

      this.loading = true

      const data = {
        name: this.campaignName,
        type: 'massive'
      }

      this.$store.dispatch('createCampaign', data).then(response => {
        notifications.success(this.$t('general.campaignSuccessfullyCreated'))
        this.$store.dispatch('uploadUsersForTheCampaignDirectly', {
          campaignId: response.campaign._id,
          file: this.file
        }).then(() => {
          this.$router.push(`/apps/${this.$store.getters.appUuid}/campaigns/${response.campaign._id}`)
          this.loading = false
        }).catch(error => {
          notifications.error(error.message)
          this.loading = false
          this.$router.push(`/apps/${this.$store.getters.appUuid}/campaigns/${response.campaign._id}`)
        })
      }).catch(error => {
        notifications.error(error.message)
        this.loading = false
      })
    }
  }
}
</script>
